module.exports = __webpack_public_path__ + "img/Rectangle 547.48524068.png";